import type { FC } from "react";
import { useTranslation } from "react-i18next";

interface IBulkPrintRideCustomFieldsProps {
  flightCodes: string;
  remarks: string | undefined;
  shouldShowFlights: boolean;
}

/** Full-width fields under the stations table. Remarks is always last and keeps its label when empty. */
export const BulkPrintRideCustomFields: FC<IBulkPrintRideCustomFieldsProps> = ({
  flightCodes,
  remarks,
  shouldShowFlights,
}) => {
  const { t } = useTranslation();

  return (
    <div className="custom-fields-block">
      {shouldShowFlights && (
        <div>
          <div className="label">{t("ride.formLabel.flightIds")}</div>
          <div className="field-value">{flightCodes}</div>
        </div>
      )}
      <div>
        <div className="label">{t("ride.formLabel.remarks")}</div>
        <div className="field-value">{remarks}</div>
      </div>
    </div>
  );
};
